module.exports = __webpack_public_path__ + "img/ico-all-delete.238af415.svg";